import { YieldHistory } from "types/YieldHistory";
import { ActionType, getType } from "typesafe-actions";
import * as yieldHistoryActions from "./yieldHistoryActions";

export type YieldHistoryState = {
  [K in yieldHistoryActions.YieldHistoryContentType]?: {
    loading?: boolean;
    data?: YieldHistory[];
    error?: string;
  };
};

export type YieldHistoryActions = ActionType<typeof yieldHistoryActions>;

export default function yieldHistory(state: YieldHistoryState = {}, action: YieldHistoryActions) {
  switch (action.type) {
    case getType(yieldHistoryActions.load):
      return { ...state, [action.contentType]: { ...state[action.contentType], loading: true } };
    case getType(yieldHistoryActions.loadSuccess):
      return {
        ...state,
        [action.contentType]: { loading: false, data: action.data, error: undefined },
      };
    case getType(yieldHistoryActions.loadFail):
      return { ...state, [action.contentType]: { loading: false, error: action.error } };
    default:
      return state;
  }
}
